import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-referral-list',
  templateUrl: './referral-list.component.html',
  styleUrls: ['./referral-list.component.scss']
})
export class ReferralListComponent {

  public is_loading_function: boolean = false;
  @Input() set playerUUID(v: any) {
    this.player_uuid = v;
    this.init();
  }
  @Output() closeEvent = new EventEmitter<boolean>();
  public player_uuid: any;
  public referrals: any = [];
  constructor(private http: HttpService) { }

  async init() {
    this.is_loading_function = true;
    let rtn:any = await this.http.post("/admin/player/referral/list", {player_uuid: this.player_uuid});
    this.referrals = rtn.referrals;
    this.is_loading_function = false;
  }
}
